import { useMemo } from 'react';

import useSPGroups from '@/hooks/swr/group/useSPGroups';
import type { SpGroupType } from '@/hooks/swr/group/useSPGroups';
import { useGlobalInfo, TOGGLE_MENU_SELECTED_GROUP_OPEN } from '@/hooks/context/useGlobalInfo';
import useActiveGroup from '@/hooks/user/useActiveGroup';

import { SideBarList } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile/Components/SideBarList';
import { GroupsMenuMobileLoading } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile/Components/MenuContent/Groups/GroupsMenuMobileLoading';

import { updateActiveItem } from '@/utils/menu/updateActiveItem';
import { getMenuItemsOrder } from '@/utils/menu/getMenuItemsOrder';

type GroupsMenuMobileContentProps = {
    groups: SpGroupType[];
};
function Content({ groups }: GroupsMenuMobileContentProps) {
    const { activeGroup, setActiveGroup } = useActiveGroup();
    const { dispatch } = useGlobalInfo();

    const orderedItems: SpGroupType[] = useMemo(() => {
        return getMenuItemsOrder<SpGroupType>({
            storageKey: 'ico-group-order',
            menuItems: groups,
            activeItemId: activeGroup?.id
        });
    }, [activeGroup?.id, groups]);

    const updateActive = (item: SpGroupType) => {
        updateActiveItem<SpGroupType>({
            storageKey: 'ico-group-order',
            itemsList: groups,
            itemSelectedId: item?.id,
            callback: () => {
                dispatch({ type: TOGGLE_MENU_SELECTED_GROUP_OPEN, payload: true });
                setActiveGroup(item);
            }
        });
    };

    return (
        <SideBarList
            data={orderedItems}
            updateActiveItem={updateActive}
            variant="group"
            activeItem={activeGroup}
        />
    );
}

export function GroupsMenuMobile() {
    const { spGroups, isLoading } = useSPGroups({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    if (isLoading) {
        return <GroupsMenuMobileLoading />;
    }

    return <Content groups={spGroups} />;
}
